import React, { useState } from 'react';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';

const CookieSettingsModal = ({ languageData, onClose }) => {
  const [preferences, setPreferences] = useState({
    essential: true,
    analytics: false,
    personalization: false,
    marketing: false,
  });

  const toggle = key => {
    setPreferences(prev => ({ ...prev, [key]: !prev[key] }));
  };

  const savePreferences = () => {
    localStorage.setItem('cookiePreferences', JSON.stringify(preferences));
    localStorage.setItem('cookiesAccepted', 'true');
    onClose();
  };

  return (
    <FlexContainer
      className={
        'pos-fixed align-items-center justify-center left0 bottom0 width100'
      }
      style={{
        zIndex: 1200,
        background: 'rgba(0,0,0,0.4)',
        height: '100vh',
      }}
      onClick={onClose}
    >
      <FlexContainer
        className={'flex-column bgWhite border-rad10px pad20 width100 margr30'}
        onClick={e => e.stopPropagation()}
      >
        <Label className={'text-18'}>
          <strong>
            {languageData === 'EN'
              ? 'Cookie Settings'
              : 'Configuración de Cookies'}
          </strong>
        </Label>

        <div className="margt20 flex-column gap-10">
          {Object.keys(preferences).map(key => (
            <label key={key} className="flex align-items-center gap-10">
              <input
                type="checkbox"
                checked={preferences[key]}
                onChange={() => toggle(key)}
              />
              {key}
            </label>
          ))}
        </div>

        <button
          className={
            'bgGradientSignUpPurple borderNone fontWhite padtb10 padlr10 width100 text-16 margt20'
          }
          onClick={savePreferences}
        >
          {languageData === 'EN' ? 'Save Preferences' : 'Guardar Preferencias'}
        </button>
      </FlexContainer>
    </FlexContainer>
  );
};

export default CookieSettingsModal;
